import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Divider,
    Link,
    styled,
    Typography,
    useTheme,
} from '@mui/material';
import LoadingSpinner from '../../common/components/LoadingSpinner';
import CommonButton from '../../common/components/CommonButton';
import { Academics, ActivitiesAt, EnrollmentStatus, EnrollmentStatusObj, ExamAttempts, FirstTimes, Profiles, ProfilesObj, ProfileTabs, ProjectTypes, removeEmptyFields, Semesters, SkipReasons, StepperContent, StudentGrade, SubjectArea, SubjectAreaObj, Subjects } from '../../common/const';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import AcademicInfo from './AcamedicInfo';
import CurricularInfo from './CurricularInfo';
import SkillsInfo from './SkillsInfo';
import ProjectInfo from './ProjectInfo';
import CommonDialog from '../../common/components/CommonDialog';
import CommonSelect from '../../common/components/CommonSelect';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { academicSuccess, loginSuccess, setLoading } from '../../features/authSlice';
import { createAcademic, createSubject, updateAcademic } from "../../api/academicApi";
import { showNotification } from '../../common/components/Notification/ToastifyNotification';
import { createProjectResearch } from '../../api/resourceApi';
import { refreshToken, updateStudent } from '../../api/authApi';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 5,
    marginTop: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.secondary.main,
        }),
    },
}));

const ProfileSetUpForm = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, academic, user } = useSelector((state) => state.auth);
    const { projectList } = useSelector((state) => state.project);
    const [step, setStep] = useState(ProfileTabs.academic);
    const [formData, setFormData] = useState({
        academic: {
            schoolname: '',
            academic: '',
            startDate: '',
            endDate: '',
            studentGrade: StudentGrade[0].value,
            subjectArea: SubjectArea[0].value,
            subject: '',
            enrollmentStatus: EnrollmentStatus[0].value,
            grade: '',
            GPA: '',
            subjectStartDate: '',
            subjectEndDate: '',
            SATSubject: Subjects[0].value,
            firstAttempt: ExamAttempts[0].value,
            examDate: '',
            bestScore: '',
            superScore: '',
            noOfAttempt: '',
            semester: Semesters?.["Semester 1"],
            semGrade: '',
            semGpa: ''
        },
        curricular: {
            activityAt: ActivitiesAt[0].value,
            activityName: '',
            noofhours: '',
            status: '',
            startdate: '',
            enddate: '',
            activityStatus: '',
            activityLocation: '',
        },
        coding: {
            status: Academics[0].value,
            courseName: '',
            proficiencyLevel: '',
            examTakenDate: '',
            codingStatus: '',
            duration: '',
            startdate: '',
            enddate: '',
            certificate: ''
        },
        projectInfo: {
            profile: Profiles[0].value,
            projectype: ProjectTypes[0].value,
            status: '',
            firstTime: FirstTimes[0].value,
            name: '',
            bankid: '',
            type: '',
            projectlevel: '',
            duration: '',
            totalhour: '',
            startdate: '',
            enddate: '',
        },
        skillCliked: false,
        activityCliked: false,
        skipReason: '',
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [finalOpen, setFinalOpen] = useState(false);

    const isNextButtonDisabled = () => {
        switch (step) {
            case 1:
                return formData.academic.schoolname === '' || formData.academic.academic === '';
            case 2:
                return !formData.activityCliked;
            case 3:
                return !formData.skillCliked
            default:
                return false;
        }
    };

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonDialog
                open={finalOpen}
                size="xs"
                content={(
                    <center>
                        <img
                            src='/Images/success.png'
                            alt='Check Circle'
                            style={{ width: '70px', height: '70px', marginTop: 20 }}
                        />
                        <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5 }}>
                            You're In!
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph mt={0.3}>
                            Your account has been created.
                        </Typography>
                    </center>
                )}
                actionButtons={(
                    <CommonButton
                        label="Let's Get In There!"
                        size="large"
                        handleClick={async () => {
                            try {
                                dispatch(setLoading({
                                    loading: true
                                }));
                                const response = await refreshToken();
                                if (response.data) {
                                    dispatch(loginSuccess({
                                        token: response.data.token,
                                    }));
                                    localStorage.removeItem('current_grade');
                                    navigate('/dashboard');
                                    dispatch(setLoading({
                                        loading: false
                                    }))
                                }
                            } catch (err) {
                                const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                showNotification(errorMessage, 'error');
                                dispatch(setLoading({
                                    loading: false
                                }));
                            }
                        }}
                    />
                )}
            />
            <CommonDialog
                open={dialogOpen}
                size="xs"
                title={
                    <Close
                        sx={{
                            color: theme.palette.background.dark, fontSize: 20,
                            float: 'right',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            setDialogOpen(false);
                        }}
                    />
                }
                content={(
                    <Box sx={{ px: 1 }}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: '24px',
                                textAlign: 'center',
                                lineHeight: 1.2,
                            }}
                        >
                            Are you sure you’d like to skip the {step === ProfileTabs.academic ? 'Basic Academic Information' : step === ProfileTabs.curricular ? 'Extracurricular Activities' :
                                step === ProfileTabs.coding ? 'Coding/Technology/Skills' : 'Research/Project'} section for now? We’ll need these details later to build your profile.
                        </Typography>

                        {/* Instruction */}
                        <Typography
                            variant="body1"
                            sx={{
                                color: theme.palette.background.dark,
                                fontSize: '14px',
                                lineHeight: 1.5,
                                textAlign: 'center',
                            }}
                        >
                            choose your reason
                        </Typography>
                        <CommonSelect
                            label="Reason"
                            name="skipReason"
                            value={formData.skipReason}
                            onChange={(e) => {
                                const { name, value } = e.target;
                                setFormData((prev) => ({
                                    ...prev,
                                    [name]: value,
                                }));
                            }}
                            placeholder="Select Reason"
                            options={SkipReasons}
                        />

                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2.5 }}>
                            <CommonButton
                                label="Comeback Later"
                                marginBottom={2}
                                disabled={formData.skipReason === ''}
                                handleClick={async () => {
                                    try {
                                        let data = {};
                                        if (step === ProfileTabs.academic) {
                                            data.academic_info_skip_reason = formData.skipReason
                                        } else if (step === ProfileTabs.curricular) {
                                            data.extra_curricular_activity_skip_reason = formData.skipReason
                                        } else if (step === ProfileTabs.coding) {
                                            data.skill_skip_reason = formData.skipReason
                                        } else {
                                            data.project_skip_reason = formData.skipReason
                                        }
                                        dispatch(setLoading({
                                            loading: true
                                        }));
                                        const response = await updateStudent(user?.student_id, data);
                                        if (response?.data?.student_id) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                skipReason: ''
                                            }))
                                            setDialogOpen(false);
                                            dispatch(setLoading({
                                                loading: false
                                            }));
                                            if (step === ProfileTabs.research) {
                                                setFinalOpen(true);
                                            } else {
                                                setStep((prev) => prev + 1);
                                            }
                                        }
                                    } catch (err) {
                                        const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                        dispatch(setLoading({
                                            loading: false
                                        }));
                                        showNotification(errorMessage, 'error');
                                    }
                                }}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    p: 0,
                                    mb: 2
                                }}>
                                <Link
                                    sx={{
                                        color: theme.palette.secondary.main,
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                        pointerEvents: 'auto', // Prevents all interactions
                                        opacity: 1,
                                        fontSize: '14px'
                                    }}
                                    onClick={() => setDialogOpen(false)}
                                >
                                    Fill Right Now
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                )}
            />
            <Box>
                <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '24px' }}>
                        {StepperContent[`Step-${step}`].title}
                    </Typography>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                    >
                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 400, color: 'text.main' }}>
                            {StepperContent[`Step-${step}`].subTitle}
                        </Typography>
                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600, color: 'text.main' }}>
                            Step <span style={{ color: theme.palette.secondary.main }}>{step}</span> of 4
                        </Typography>
                    </Box>
                    <BorderLinearProgress variant="determinate" value={((step / 4) * 100)} />
                </Box>
                {step === ProfileTabs.academic && (
                    <AcademicInfo
                        formData={formData}
                        setFormData={setFormData}
                    />
                )}
                {step === ProfileTabs.curricular && (
                    <CurricularInfo
                        formData={formData}
                        setFormData={setFormData}
                    />
                )}
                {step === ProfileTabs.coding && (
                    <SkillsInfo
                        formData={formData}
                        setFormData={setFormData}
                    />
                )}
                {step === ProfileTabs.research && (
                    <ProjectInfo
                        formData={formData}
                        setFormData={setFormData}
                    />
                )}
                <Divider />
                <Box
                    display="flex"
                    justifyContent="space-between"
                    gap={1}
                    mt={2}
                >
                    <CommonButton
                        label="Skip"
                        background={theme.palette.background.main}
                        color={theme.palette.background.dark}
                        height="40px"
                        width="70px"
                        marginBottom="0px"
                        fontWeight="bold"
                        border="1px solid lightgray"
                        handleClick={() => setDialogOpen(true)}
                    />
                    <Box
                        display="flex"
                        gap={1}
                    >
                        {step > ProfileTabs.academic && (
                            <CommonButton
                                label="Previous"
                                background={theme.palette.background.main}
                                color={theme.palette.background.dark}
                                height="40px"
                                width="100px"
                                marginBottom="0px"
                                fontWeight="bold"
                                border="1px solid lightgray"
                                handleClick={() => setStep((prev) => prev - 1)}
                            />
                        )}
                        {step < ProfileTabs.research &&
                            (<CommonButton
                                label="Next"
                                height="40px"
                                marginBottom="0px"
                                fontWeight="bold"
                                disabled={isNextButtonDisabled()}
                                width={step > ProfileTabs.academic ? "100px" : "150px"}
                                handleClick={async () => {
                                    if (step === ProfileTabs.academic) {
                                        let academicRes;
                                        const data = {
                                            "school_name": formData.academic.schoolname,
                                            "academic_status": formData.academic.academic,
                                            "start_date": formData.academic.startDate !== '' ? new Date(formData.academic.startDate).toISOString() : null,
                                            "end_date": formData.academic.endDate !== '' ? new Date(formData.academic.endDate).toISOString() : null,
                                            "student_grade": formData.academic.studentGrade,
                                            "student_id": user.student_id
                                        };
                                        if (academic === null) {
                                            dispatch(setLoading({
                                                loading: true
                                            }));
                                            const response = await createAcademic(removeEmptyFields(data));
                                            if (response.data.academic_id) {
                                                academicRes = response.data;
                                                dispatch(academicSuccess({
                                                    academic: response.data
                                                }));
                                                showNotification('Academic info added successfully', 'success');
                                                dispatch(setLoading({
                                                    loading: false
                                                }));
                                            }
                                        } else {
                                            const response = await updateAcademic(academic?.academic_id, removeEmptyFields(data));
                                            if (response.data.academic_id) {
                                                academicRes = response.data;
                                                dispatch(academicSuccess({
                                                    academic: response.data
                                                }));
                                                showNotification('Academic info updated successfully', 'success');
                                                dispatch(setLoading({
                                                    loading: false
                                                }));
                                            }
                                        }
                                        localStorage.setItem('current_grade', formData.academic.studentGrade);
                                        if (formData.academic.academic === 'CURRENT') {
                                            updateStudent(user?.student_id, {
                                                student_current_grade: formData.academic.studentGrade
                                            });
                                        }
                                        if ((academic?.academic_id || academicRes?.academic_id) && (formData.academic.subject !== '' || (formData.academic.SATSubject && formData.academic.examDate && formData.academic.examDate !== ''))) {
                                            dispatch(setLoading({
                                                loading: true
                                            }));
                                            const subjecResponse = await createSubject({
                                                subject_name: formData.academic.subject || Subjects.find((a) => a.value === formData.academic.SATSubject).label,
                                                subject_area: SubjectAreaObj[formData.academic.subjectArea],
                                                enrollment_status: formData.academic.enrollmentStatus ? EnrollmentStatusObj[formData.academic.enrollmentStatus] : null,
                                                super_score: formData.academic.superScore || 0,
                                                best_score: formData.academic.bestScore || 0,
                                                grade: formData.academic.grade,
                                                gpa: formData.academic.GPA,
                                                start_date: formData.academic.subjectStartDate && formData.academic.subjectStartDate !== '' ? new Date(formData.academic.subjectStartDate).toISOString() : null,
                                                end_date: formData.academic.subjectEndDate && formData.academic.subjectEndDate !== '' ? new Date(formData.academic.subjectEndDate).toISOString() : null,
                                                is_first_attempt: ExamAttempts.find((a) => a.value === formData.academic.firstAttempt)?.label === 'Yes',
                                                no_of_test_taken: formData.academic.noOfAttempt || 0,
                                                test_date: formData.academic.examDate && formData.academic.examDate !== '' ? new Date(formData.academic.examDate).toISOString() : null,
                                                is_active: true,
                                                academic_id: academic?.academic_id || academicRes?.academic_id,
                                                student_id: user?.student_id,
                                                semester: formData?.academic?.semester,
                                                semester2_grade: formData?.academic?.semGrade,
                                                semester2_gpa: formData?.academic?.semGpa
                                            });
                                            if (subjecResponse) {
                                                showNotification('Academic subject added successfully', 'success');
                                                dispatch(setLoading({
                                                    loading: false
                                                }));
                                                setStep((prev) => prev + 1);
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    academic: {
                                                        ...prev.academic,
                                                        schoolname: academic?.school_name || '',
                                                        academic: academic?.academic_status || '',
                                                        startDate: academic?.start_date || '',
                                                        endDate: academic?.end_date || '',
                                                        subjectArea: SubjectArea[0].value,
                                                        subject: '',
                                                        enrollmentStatus: EnrollmentStatus[0].value,
                                                        grade: '',
                                                        GPA: '',
                                                        subjectStartDate: '',
                                                        subjectEndDate: '',
                                                        SATSubject: Subjects[0].value,
                                                        firstAttempt: ExamAttempts[0].value,
                                                        examDate: '',
                                                        bestScore: '',
                                                        superScore: '',
                                                        noOfAttempt: '',
                                                        semester: Semesters?.["Semester 1"],
                                                        semGrade: '',
                                                        semGpa: ''
                                                    },
                                                }));
                                            }
                                        } else {
                                            setStep((prev) => prev + 1);
                                        }
                                    } else {
                                        setStep((prev) => prev + 1);
                                    }
                                }}
                            />)}
                        {step === ProfileTabs.research &&
                            (<CommonButton
                                label="Complete Profile"
                                height="40px"
                                marginBottom="0px"
                                fontWeight="bold"
                                width="140px"
                                handleClick={async () => {
                                    if (formData.projectInfo.name !== '' || formData.projectInfo.bankid !== '') {
                                        try {
                                            dispatch(setLoading({
                                                loading: true
                                            }));
                                            const response = await createProjectResearch(removeEmptyFields({
                                                "project_profile": formData.projectInfo.profile,
                                                "project_name": formData.projectInfo.name || projectList.find((a) => a.project_bank_id === formData.projectInfo.bankid)?.project_name,
                                                "project_level": formData.projectInfo.projectlevel !== '' ? formData.projectInfo.projectlevel : null,
                                                "project_source": formData.projectInfo.projectype !== '' ? formData.projectInfo.projectype : null,
                                                "project_type": formData.projectInfo.type,
                                                "project_bank_id": formData.projectInfo.bankid !== '' ? formData.projectInfo.bankid : null,
                                                "is_it_first_time": true,
                                                "project_duration": formData.projectInfo.duration,
                                                "total_hours": formData.projectInfo.totalhour,
                                                "status": formData.projectInfo.status,
                                                "is_active": true,
                                                "start_date": formData.projectInfo.startdate !== '' ? new Date(formData.projectInfo.startdate).toISOString() : null,
                                                "end_date": formData.projectInfo.enddate !== '' ? new Date(formData.projectInfo.enddate).toISOString() : null,
                                                "student_grade": localStorage.getItem('current_grade'),
                                                "student_id": user.student_id
                                            }));
                                            if (response.project_id) {
                                                showNotification(`${formData.projectInfo.profile === ProfilesObj.Research ? 'Research' : 'Project'} added successfully`, 'success');
                                                dispatch(setLoading({
                                                    loading: false
                                                }));
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    projectInfo: {
                                                        profile: Profiles[0].value,
                                                        projectype: ProjectTypes[0].value,
                                                        status: '',
                                                        firstTime: FirstTimes[0].value,
                                                        name: '',
                                                        bankid: '',
                                                        type: '',
                                                        projectlevel: '',
                                                        duration: '',
                                                        totalhour: '',
                                                        startdate: '',
                                                        enddate: '',
                                                    },
                                                }));
                                            }
                                        } catch (err) {
                                            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                            showNotification(errorMessage, 'error');
                                            dispatch(setLoading({
                                                loading: false
                                            }));
                                        }
                                    }
                                    setFinalOpen(true);
                                }}
                            />)}
                    </Box>
                </Box>
            </Box>
        </Fragment>
    );
};

export default ProfileSetUpForm;